module.exports = "<div class=\"row wrapper border-bottom white-bg page-heading personal-account-header\">\r\n    <div class=\"col-lg-12\">\r\n        <h2>Book a Demo</h2>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"help-book-demo-page personal-account-page\">\r\n    <div\r\n        #calendlyWidget\r\n        class=\"calendly-inline-widget help-book-demo-widget\"\r\n        [attr.data-url]=\"calendlyUrl\">\r\n    </div>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./Client/app/views/account.management/help/help.book-demo.component.html
// module id = 1161
// module chunks = 0